
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
// import * as $ from 'jquery';

@Component({
  selector: 'app-all-categories',
  templateUrl: './all-categories.component.html',
  styleUrls: ['./all-categories.component.scss'],
})

export class AllCategoriesComponent implements OnInit {
  public videoCategoryData: any;
  subCategory: any = [];
  additionalSubCategory: any = [];
  siteURL = environment.siteURL;
  assetURL = environment.assetURL;
  constructor(public sharedService: SharedService) {

  }
  ngOnInit(): void {
    if (this.sharedService.videoCategoryData != undefined) {
      this.videoCategoryData = this.sharedService.videoCategoryData;
      this.loadSubCategory();
    } else {
      this.sharedService.isVideoCategoryDataAvailable.subscribe(
        (data: any) => {
          if (data) {
            this.loadSubCategory();
          }
        }
      );
    }
  }
  private loadSubCategory() {
    this.videoCategoryData = this.sharedService.videoCategoryData;
    this.videoCategoryData.forEach(categoryItem => {
      this.subCategory.push(...categoryItem.SubCategoryData);
    });
  }
}